import IntakeCategorizedDisplay from "./IntakeCategorizedDisplay"

/**
 * Read-only saved brokerage profile intake, grouped by form category.
 */
export default function BrokerageProfileIntakeSummary({ intake, websiteUrl }) {
  return <IntakeCategorizedDisplay intake={intake} websiteUrl={websiteUrl} />
}
